import { render } from "./MarketingLayout.vue?vue&type=template&id=bd7bb0ee&scoped=true"
import script from "./MarketingLayout.vue?vue&type=script&lang=js"
export * from "./MarketingLayout.vue?vue&type=script&lang=js"

import "./MarketingLayout.vue?vue&type=style&index=0&id=bd7bb0ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd7bb0ee"]])

export default __exports__